/* eslint-disable no-bitwise */
/* eslint-disable no-empty */
import classNames from "components/ui/classNames";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import imgixLoader from "lib/loaders/imgixLoader";
import { blurHashToDataURL } from "lib/utils/blurHashToDataURL";
import Image from "next/image";

interface IBrazilianCompanyCoverProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment;
}

function BrazilianCompanyCover({ issuer }: IBrazilianCompanyCoverProps) {
  const { covers } = issuer;
  const primaryColor = issuer.niceLogo?.dominantColor || issuer.standardLogo?.dominantColor || undefined;
  let blurDataURL: string | undefined;
  try {
    blurDataURL = blurHashToDataURL(covers[0].blurhash);
  } catch {}

  return (
    <div
      className="absolute top-0 z-0 w-full border-b-8 border-b-black"
      style={{
        borderBottomColor: primaryColor,
      }}
    >
      {covers.length === 0 ? (
        <div
          className={classNames("h-[768px] w-full", {
            "bg-gradient-to-r from-brand/90 to-emerald-400": !primaryColor,
          })}
          style={{ backgroundColor: primaryColor }}
        />
      ) : (
        <div
          style={{ backgroundColor: primaryColor }}
          className={classNames("relative h-[768px] w-full bg-no-repeat", {
            "bg-gradient-to-r from-brand/90 to-emerald-400": !primaryColor,
          })}
        >
          <Image
            loader={imgixLoader}
            placeholder={blurDataURL ? "blur" : "empty"}
            blurDataURL={rgbDataURL(primaryColor || "#000000")}
            src={covers[0].url}
            alt={`Capa de ${issuer.name}`}
            fill={true}
            quality={80}
            priority={true}
            className="object-cover object-top"
          />
        </div>
      )}
      <div
        className="absolute top-0 left-0 h-full w-full"
        style={{
          background: "linear-gradient(360deg, #212121, 20%, rgba(0, 0, 0, 0) 90%)",
        }}
      />
    </div>
  );
}

export default BrazilianCompanyCover;

// Pixel GIF code adapted from https://stackoverflow.com/a/33919020/266535
const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

const triplet = (e1: number, e2: number, e3: number) => {
  return (
    keyStr.charAt(e1 >> 2) +
    keyStr.charAt(((e1 & 3) << 4) | (e2 >> 4)) +
    keyStr.charAt(((e2 & 15) << 2) | (e3 >> 6)) +
    keyStr.charAt(e3 & 63)
  );
};

const rgbDataURL = (hex: string) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  const triplets = triplet(0, r, g) + triplet(b, 255, 255);
  return `data:image/gif;base64,R0lGODlhAQABAPAA${triplets}/yH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==`;
};
